import { useQuery } from '@tanstack/react-query';

import {
  type SourcesGitAuthInfo,
  type SourcesSourceDetail,
} from '@api/types.gen';
import { gitOpsSourceGet } from '@api/sdk.gen';

import { withError } from '@/react-tools/react-query';

import { SourceId } from '../types';

import { sourceQueryKeys } from './query-keys';

export type GitAuthInfo = SourcesGitAuthInfo;

export type SourceDetail = SourcesSourceDetail;

export function sourceOptions(id: SourceId) {
  return {
    queryKey: sourceQueryKeys.detail(id),
    queryFn: () => getSource(id),
    ...withError('Failed loading source'),
  };
}

export function useSource(id: SourceId | undefined) {
  return useQuery({
    ...sourceOptions(id!),
    enabled: !!id,
  });
}

async function getSource(id: SourceId): Promise<SourceDetail> {
  const { data } = await gitOpsSourceGet({ path: { id } });

  return data;
}
